import { AttachFileButton } from '../Chat/ChatButtons/AttachFileButton'
import { useContext as useChatContext } from '../Chat/Context'
import { useChannelContext } from '../Channel/Context'
import { ComposerToolbarEnd } from '../Channel/ComposerToolbarEnd'
import { ConversationActions } from './ConversationActions'
import { ConversationDetailLink } from './ConversationDetailLink'
import { chatPermissions } from '@ztechapps/chat.common'
import { useRole } from '@ztechapps/common.hook'

export type ConversationComposerToolbarEndProps = {
  /** The document-side conversation id. Omitted where there is no document-side thread to jump
      to — the inbox mounts this same toolbar, and the jump renders nothing without one. */
  conversationId?: string
  /** True on the document-side mounts (sales order, purchase order, logistics) — the inbox thread is already a conversation. */
  canAttachConversation?: boolean
}

// End-slot content for every compact composer: the templates select, the host's other buttons
// (Refresh and AI Formalize by default), the conversation jump, Attach and the send control, in
// the footer row's order.
export const ConversationComposerToolbarEnd = ({
  conversationId,
  canAttachConversation,
}: ConversationComposerToolbarEndProps) => {
  const { components, ...rest } = useChatContext()
  const { attachments, addAttachments } = useChannelContext()
  const { hasRole: canAttach } = useRole({ roleName: chatPermissions.canEdit.value })

  return (
    <ComposerToolbarEnd templateSelect={<components.chatActions.leftContent {...rest} />}>
      <components.chatActions.otherButtons {...rest} />
      {/* document-side mounts fold the jump and the attach into one dropdown; the inbox keeps the jump alone */}
      {canAttachConversation ? (
        <ConversationActions conversationId={conversationId} />
      ) : (
        <ConversationDetailLink conversationId={conversationId} />
      )}
      <AttachFileButton
        attachments={attachments}
        onAttach={addAttachments}
        disabled={rest.status?.busy}
        disabledReason={canAttach ? undefined : 'You need the Conversation edit permission to attach files.'}
        variant="link"
      />
      <components.sendMessageButton {...rest} />
    </ComposerToolbarEnd>
  )
}
